if (!customElements.get('miyabi-availability-button')) {
  customElements.define('miyabi-availability-button', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('product-form');
      this.button = this.form?.querySelector('button[name="add"]');
      this.label = this.button?.querySelector('span');
      this.input = this.form?.querySelector('input[name="id"]');
      this.status = this.querySelector('[role="status"]');
      if (!this.input || !this.label) return;
      this.rules = JSON.parse(this.querySelector('script').textContent);
      this.sizes = JSON.parse(this.querySelector('[data-variant-sizes]')?.textContent || '{}');
      this.refresh = this.update.bind(this);
      this.form.addEventListener('change', this.refresh);
      document.addEventListener('visibilitychange', this.refresh);
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(this.button, { attributes: true, childList: true, subtree: true, characterData: true, attributeFilter: ['disabled','aria-disabled','class'] });
      this.timer = setInterval(this.refresh, 15000);
      this.update();
    }
    disconnectedCallback() {
      this.form?.removeEventListener('change', this.refresh);
      document.removeEventListener('visibilitychange', this.refresh);
      this.observer?.disconnect(); clearInterval(this.timer);
    }
    update() {
      const A = window.MiyabiAvailability, T = window.miyabiAvailabilityText;
      const rule = this.rules[this.input.value];
      if (!A || !T || !rule) { this.status.textContent = ''; return; }
      if (this.button.classList.contains('loading') || this.button.getAttribute('aria-disabled') === 'true') return;
      const base = this.button.disabled ? window.variantStrings.soldOut : window.variantStrings.addToCart;
      if (![base,this.lastLabel].includes(this.label.textContent.trim())) { this.status.textContent = ''; return; }
      const now = A.clock(), next = A.earliest([rule], A.blocks(this.dataset.blocked), now);
      const ready = A.readiness(rule, now), today = A.calendar(now).day;
      let label = base, message = '';
      const fill = (s, values) => Object.entries(values).reduce((t,[k,v]) => t.replaceAll(`__${k}__`, v), s);
      if (next && (!this.button.disabled || A.parseDate(rule.date) > today)) {
        const date = A.dateText(next.day), time = A.timeText(next.slot.start);
        const size = this.sizes?.[this.input.value];
        message = fill(size && this.dataset.sizeEarliest ? this.dataset.sizeEarliest : T.earliest,{SIZE:size || '',DATE:date,TIME:time});
        if (this.button.disabled) message = T.soldOut;
        else if (ready.cutoff > 0 && ready.closed) message = fill(T.preparationClosed,{TIME:A.timeText(ready.cutoff*60)}) + ' ' + message;
        else if (ready.cutoff > 0 && (next.day === today || ready.lead > 0)) message += ' ' + fill(T.preparationCutoff,{TIME:A.timeText(ready.cutoff*60)});
      } else if (!next) message = T.noSlots;
      this.lastLabel = label;
      if (this.label.textContent.trim() !== label) this.label.textContent = label;
      if (this.status.textContent !== message) this.status.textContent = message;
    }
  });
}
